import { useMemo, useState } from "react";

import { SidebarNames } from "../../namesConstants/names";
import { SidebarCatalogsComponent } from "../../components/SidebarCatalogsComponent";

import { UpdateDataRequests } from "./components/UpdateDataRequests";
import { VacationRequests } from "./components/VacationRequests";

const VacationScreen = () => {
  const [itemSelected, setItemSelected] = useState(1);
  const [currentTap, setCurrentTap] = useState({ id: 1 });
  const [isOpen, setIsOpen] = useState(true);

  const children = useMemo(
    () => [
      {
        name: "Cambio de datos",
        icon: "GiVacations",
        children: [
          {
            id: 1,
            url: "/requests/update-data",
            name: "update-data",
            title: SidebarNames.SidebarUpdateDataRequests,
            tapTitle: SidebarNames.SidebarUpdateDataRequests,
            icon: "MdOutlineSettingsInputComponent",
            translate: SidebarNames.SidebarUpdateDataRequests,
            type: "item",
          },
        ],
      },
      {
        name: "Vacaciones y Permisos",
        icon: "GiVacations",
        children: [
          {
            id: 2,
            url: "/requests/vacations",
            name: "vacations",
            title: SidebarNames.SidebarVacationsRequests,
            tapTitle: SidebarNames.SidebarVacationsRequests,
            icon: "VacationsRequests",
            translate: SidebarNames.SidebarVacationsRequests,
            type: "item",
          },
        ],
      },
    ],
    []
  );

  const renderComponent = (valueSelect) => {
    switch (valueSelect) {
      case 1:
        return <UpdateDataRequests />;
      case 2:
        return <VacationRequests />;
      default:
        break;
    }
  };

  return (
    <div className="flex w-full h-full flex-row">
      <SidebarCatalogsComponent
        isOpen={isOpen}
        setCurrentTap={setCurrentTap}
        currentTap={currentTap}
        setIsOpen={setIsOpen}
        setItemSelected={setItemSelected}
        Data={children}
      />
      <div className="flex h-full flex-grow">
        {renderComponent(itemSelected)}
      </div>
    </div>
  );
};

export default VacationScreen;
